import { PollingAbstractService } from '../../shared/services/abstract/polling.abstract.service';
import { AllExports } from '../../shared/models/generated/ziroModels';
import { inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class MigrationsAssessmentsPollingService extends PollingAbstractService<AllExports> {
  private _route = inject(ActivatedRoute);

  baseUrl = '';

  constructor() {
    super();
    const tenantId = this._route.snapshot.params.tenantId;
    this.baseUrl = `/services/microsoft/migrations/tenants/${tenantId}/exports`;
  }
}
